interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'Plaid', src: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js'}
];


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/script.store.ts